import { useState } from "react";

import { nanoid } from '@reduxjs/toolkit'
import useAlert from "hooks/useAlert";

import BaseModal from "dashboard/components/MDModal"; 
import ImageCropDialog from "./ImageCropDialog";
import FileUploader from "../CostumFormFields/FileUploader";

const initData = [];

const ImageCropper = ({ profilImage, handleUpload, errorUpload, isLoading, imgType, sx, cardId = null }) => {
  
  
  const [show, setShow] = useState(false);
  const toggleModal = () => setShow(!show);
  // this 2 lignes
  const {showAlerts} = useAlert();

  const [images, setImages] = useState(initData);
  const [extension, setExtension] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);

  const onCancel = () => {
    toggleModal();
    setSelectedImage(null);
  };
  // this function
  const sendFiles = async cropedImage => {
    
    const blob = cropedImage["-1"]?.croppedImageUrl;
    const fileupload = new File([blob?.file], `image_${nanoid()}.${extension}`, { type : blob?.file.type });
    // Object 
    const formData = new FormData();
    if( !selectedImage){
      showAlerts({code:"warning", msg : "please select a photo to upload", title: "Profile update " ,type : "toast"});
      return false
    }
    formData.append("file", fileupload);
    if (typeof cardId === "object" && cardId !== null) {
      formData.append("cardIndex", JSON.stringify(JSON.stringify(cardId)));
    }else{
      cardId !== null && formData.append("cardIndex", JSON.stringify(cardId));
    }
   
    /*eslint-disable*/
    imgType ? formData.append("imageType",imgType) : null;

    const response = await handleUpload(formData);

    if(response.data?.status === "success" ) {
      setSelectedImage(null);
      setExtension(null);
      setImages(initData)
      setShow(false);
    }
    return true;
  }
  
  const setCroppedImageFor = (id, crop, zoom, rotation, aspect, croppedImageUrl) => {
    const newImagesList = [...images];
    const imageIndex = images.findIndex((x) => x.id === id);
    const image = images[imageIndex];
    const newImage = { ...image, croppedImageUrl, crop, zoom, rotation, aspect};
    newImagesList[imageIndex] = newImage;
    setImages(newImagesList);
    sendFiles(newImagesList);
  };

  const handleCropper = image =>{
    if(image){
      setSelectedImage(image?.imageUrl);
      setExtension(image?.name?.split('.').pop());
    }
  }

  return (
    <div>
      
      <FileUploader 
        imagesList={images}  
        handleFile={handleCropper} 
        toggleModal={toggleModal} 
        isLoading={isLoading} 
        profilImage={profilImage} 
        error={errorUpload}
        imgType={imgType}
        sx={sx}
        />
      <BaseModal show={show} toggleModal={toggleModal} title="Modify your image">
      {selectedImage ? (
        <ImageCropDialog
          id={selectedImage.id}
          imageUrl={selectedImage}
          cropInit={selectedImage.crop}
          zoomInit={selectedImage.zoom}
          rotateInit={selectedImage.rotation}
          aspectInit={selectedImage.aspect}
          extension={extension}
          onCancel={onCancel}
          setCroppedImageFor={setCroppedImageFor}
          isLoading={isLoading}
        />
      )  : null}
      </BaseModal>
    </div>
  );
}

export default ImageCropper;